<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <Nav :title="'住院费用'"> </Nav>
      <div class="top"></div>
    </div>
    <div class="input">
      <van-form>
        <van-field
          readonly
          clickable
          name="calendar"
          :value="begindate"
          label="开始日期"
          placeholder="点击选择开始日期"
          @click="showCalendar = true"
        />
        <van-calendar
          v-model="showCalendar"
          @confirm="onConfirm"
          color="#5B8DF6"
          :min-date="minDate"
          :max-date="maxDate"
        />
        <van-field
          readonly
          clickable
          name="calendar"
          :value="enddate"
          label="结束日期"
          placeholder="点击选择结束日期"
          @click="showCalendar1 = true"
        />
         <van-field
          v-model="hospitalizationId"
          name="住院号"
          label="住院号"
          placeholder="请填写住院号"
          :rules="[{ required: true, message: '住院号不能为空' }]"
        />
        <van-calendar
          v-model="showCalendar1"
          @confirm="onConfirm1"
          color="#5B8DF6"
          :min-date="minDate"
          :max-date="maxDate"
        />
      </van-form>
      <div class="text">*开始日期与结束日期相同查询单天费用</div>
    </div>
    <div class="foot">
      <div class="foot_button">
        <van-button
          type="info"
          size="large"
          round
          class="vant_btn"
          @click="godetail()"
          >查询</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      begindate: "",
      enddate: "",
      showCalendar: false,
      showCalendar1: false,
      hospitalizationId: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2022, 0, 31),
    };
  },
  components: {
    Nav,
  },
  methods: {
    onClickLeft() {
      this.$router.push("/index");
    },
    onConfirm(date) {
      this.begindate = `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()} `;

      this.showCalendar = false;
    },
    onConfirm1(date) {
      this.enddate = `${date.getFullYear()}-${
        date.getMonth() + 1
      }-${date.getDate()}`;
      this.showCalendar1 = false;
    },
    godetail() {
      if (!this.hospitalizationId || !this.begindate || !this.enddate) {
        this.$toast.fail("请完善信息");
        return;
      }
      this.$router.push({
        path: "/hospitalization_detail_D_a",
        query: {
          InPatientId: this.hospitalizationId,
          BeginDate: this.begindate + " 00:00:00",
          EndDate: this.enddate + " 23:59:59",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  .nav {
    height: 6vh;
    
    .top {
      height: 6vh;
    }
  }
  .input {
    width: 100%;
    height: 80vh;
    margin-top: 2vh;
    .text {
      font-size: 14px;
      color: #999;
      width: 95%;
      margin: 0px auto;
    }
  }
  .foot {
    height: 14vh;
    width: 100%;
    .foot_button {
      width: 95%;
      margin: 0px auto;
      .vant_btn {
        letter-spacing: 10px;
      }
    }
  }
}
</style>
